import React, { Component } from 'react';
import './StayName.scss';

const StayName = (props) => {
    const name = props.stays[props.locationIndex].StayName;

    return (
        <h1 className='stay-name'>{name}</h1>
    );
};

export default StayName;



// WEBPACK FOOTER //
// ./application/components/StayName/StayName.jsx